module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h11 sigilNotInTOC",
    attrs: {
      "id": "heading_id_2"
    }
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("CAST OF CHARACTERS")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Roberta Grey")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Lord Charles Lamprey")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Lady Charles Lamprey")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Henry Lamprey,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("their eldest son")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Friede Lamprey (Frid),")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("their elder daughter")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Colin And Stephen Lamprey,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("twins, their second and third sons")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Patricia Lamprey (Patch),")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("their second daughter")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Michael Lamprey (Mike),")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("their youngest son")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Mrs. Burnaby (Nanny),")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("their nurse")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Baskett,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("their butler")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Cora Blackburn,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("their parlour-maid")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Stamford,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("a commissionaire")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Grimball,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("a “bum”")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("The Lady Katherine Lobe,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("aunt to Lord Charles")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Gabriel, Marquis Of Wutherwood And Rune (Uncle G.),")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("elder brother to Lord Charles")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Violet, Marchioness Of Wutherwood And Rune (Aunt V.),")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("his wife")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Giggle,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("their chauffeur")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Tinkerton,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("Lady Wutherwood’s maid")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Dr. Kantripp,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("the Lampreys’ doctor")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Sir Matthew Cairnstock,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("a brain specialist")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Dr. Curtis,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("police surgeon")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Detective-Inspector Fox")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("of the Central Branch, Criminal Investigation Department")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Chief Detective-Inspector Alleyn")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("of the Central Branch, Criminal Investigation Department")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Detective-Sergeant Bailey,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("a finger-print expert")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Detective-Sergeant Thompson,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("a photographic expert")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Police-Constable Martin")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Police-Constable Gibson,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("a police-constable who has read “Macbeth”")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Detective-Sergeant Campbell,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("on duty at 24 Brummell Street")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Nigel Bathgate,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("Watson to Mr. Alleyn")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Mrs. Moffatt,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("housekeeper at 24 Brummell Street")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Moffatt,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("her husband")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Mr. Rattisbon,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("solicitor")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d03dcc8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/FrontOther01.vue
// module id = 66
// module chunks = 0